import { ClassValue, clsx } from 'clsx';
import moment, { Moment } from 'moment';
import { twMerge } from 'tailwind-merge';

export function cn(...args: ClassValue[]) {
  return twMerge(clsx(args));
}

export const joinClassNames = (...classes: (string | undefined | false | null)[]) =>
  classes.filter(Boolean).join(' ');
export const isCrm = typeof window !== 'undefined' && window.location.href.includes('crm');

export const getLocalStorageOrDefault = (
  key: string,
  defaultValue?: string,
): string | undefined => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const stored = window.localStorage.getItem(key);

    if (stored) {
      return stored;
    } else {
      return defaultValue;
    }
  }
};

export const deleteLocalStorage = (key: string): void => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.removeItem(key);
  }
};

export const getSessionStorageOrDefault = (
  key: string,
  defaultValue?: string,
): string | undefined => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    const stored = window.sessionStorage.getItem(key);

    if (stored) {
      return stored;
    } else {
      return defaultValue;
    }
  }
};

export const deleteSessionStorage = (key: string): void => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    window.sessionStorage.removeItem(key);
  }
};

export const formatDate = (date: string | Moment | Date, includeTime?: boolean) =>
  moment(date).format(`DD/MM/YYYY${includeTime ? ' HH:mm' : ''}`);

export const getObjectValue = (obj: any, path: string): any => {
  const keys = path.split('.'); // Split the path string into an array of keys

  let value = obj;
  for (const key of keys) {
    value = value[key];
    if (value === undefined) {
      return undefined; // Return undefined if any intermediate key does not exist
    }
  }

  return value;
};

export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
